<template>
  <div class="query-form">

    <a-row type="flex" style="width: 100%;">
      <!-- <a-col :sm="24" :md="24" :lg="12" :xl="8">
        

      </a-col> -->
      <a-col :sm="24" :md="24" :lg="21" :xl="21">
        <!-- 关键词搜索 -->
        <div class="search-keyword">
          <a-input placeholder="输入关键字搜索" v-model="blurry" style="margin: 0 20px;" @pressEnter="blurrySearch"></a-input>
          <a-button @click="blurrySearch" type="primary">搜索</a-button>
          <a-button v-if="isFilter" type="primary" class="reset-search" ghost icon="close-circle" @click="resetFields">重置搜索</a-button>
        </div>
        
        <!-- <a-button-group style="float:left;margin: 8px 20px  8px 0;">
          <a-button @click="toggleType(1)" :type="state === 1 ? 'primary' : ''">全部</a-button>
          <a-button @click="toggleType(2)" :type="state === 2 ? 'primary' : ''">已认证</a-button>
          <a-button @click="toggleType(3)" :type="state === 3 ? 'primary' : ''">未认证</a-button>
        </a-button-group> -->
        <div class="popupContainer">
          <a-popover 
          class="advanced-search"
          placement="bottomLeft"
          trigger="click"
          v-model="searchVisible">
            <template slot="content">
              <a-form :form="form" style="width:350px;" class="form-container">
                <a-row>
                  <a-col :sm="24" :md="24" :lg="24" :xl="24">
                    <a-form-item v-bind="formItemLayout" label="认证状态" colon > 
                      <a-select v-decorator='["state",{
                        initialValue:state
                      }]' style="min-width:80px;margin-right: 20px;">
                        <a-select-option v-for ="item in stateList" :value="item.key" :key="item.key">{{item.value}}</a-select-option>
                      </a-select> 
                    </a-form-item>
                  </a-col>
                  <a-col :sm="24" :md="24" :lg="24" :xl="24">
                    <a-form-item v-bind="formItemLayout" label="地区选择" colon >
                      <a-cascader  v-decorator='["region"]' :options="cascaderOptions" @change="regionOnChange" :showSearch="{filter}" placeholder="请选择地区" />
                    </a-form-item>
                  </a-col>
                  <a-col :sm="24" :md="24" :lg="24" :xl="24" style="text-align:center;">
                    <a-button type="primary" style="margin-right:40px;" @click="resetFields"> 重置 </a-button>
                    <a-button type="primary"  @click="advancedSearchhandleOk"> 查询 </a-button>
                  </a-col>
                </a-row>
            </a-form>
            </template>
            <template slot="title">
              <h2 style="font-weight: bold; line-height:32px;">高级搜索</h2>
            </template>
          <a-button type="text" v-if="!isFilter" icon="search" style="color:#40a9ff;">高级搜索</a-button>
          </a-popover>
        </div>
        
      </a-col>
      <a-col :sm="24" :md="24" :lg="3" :xl="3">
        <!-- 添加证书 -->
        <a-button v-if="roles.includes('USERDEPT_CREATE')" type="primary" style="float:right;margin: 8px 20px 8px 0px;" @click="openAddClient()">添加客户</a-button>
      </a-col>
    </a-row>




  </div>
</template>

<script>
let stateList = [
  {key:'1',value:'全部'},
  {key:'2',value:'已认证'},
  {key:'3',value:'未认证'},
]
import {invite,clientManage} from '@/api/user'
export default {
  data() {
    return {
      doc: document,
      stateList,
      blurry:'',
      state: '1',
      loading: false,
      searchVisible:false,
      formItemLayout:{
        labelCol: {
            span: 5
        },
        wrapperCol: {
            span: 17
        },
      },
      form: this.$form.createForm(this),
      cascaderOptions:[],
      advancedSearchParams:{
        state:'',
        region:'',
      },
      selectedRegion:'',
      isFilter: false,
      roles: []
    };
  },
  mounted() {
    this.cascaderOptions = this.$province;
    let userMsg = this.$store.state.user.user;
    this.roles = userMsg.roles;
  },
  methods: {
    blurrySearch(){
      this.$emit('blurrySearch',this.blurry)
    },
    //添加客户
    openAddClient(){
      this.$emit('openAddClient',true)
      this.visible = true
    },
    // 选择状态
    // toggleType(state) {
    //   this.state = state
    //     this.$emit("toggleType",this.state)
    // },
    /**
     * 高级搜索
     */
    advancedSearchhandleOk(){
      this.searchVisible= false
      const formObj = this.form.getFieldsValue()
      if(formObj.state){
        this.advancedSearchParams.state = formObj.state
      }
      if(this.selectedRegion){
        this.advancedSearchParams.region = this.selectedRegion
      }else{
        this.advancedSearchParams.region = ''
      }
      this.$emit("advancedSearchhandleOk",this.advancedSearchParams)
      this.isFilter = true;
    },

    /**
     * 重置搜索
     */
    resetFields(){
      this.selectedRegion = '';
      this.form.resetFields();
      this.advancedSearchhandleOk();
      this.isFilter = false;
    },
    /**
     *地区选择 
     */
    regionOnChange(value, selectedOptions){
      if(selectedOptions){
        let selectedLabel = []
        selectedOptions.filter(item => {
          selectedLabel.push(item.value)
        })
        this.selectedRegion = selectedLabel.join(',')
      }else{
        this.selectedRegion = ''
      }
      
    },
    filter(inputValue, path) {
      return path.some(
        option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1,
      );
    },
  }
};
</script>

<style lang="less" scoped>
.query-form {
  background-color: #fff;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  &::after{
    content:'';
    clear:both;
    display: block;
  }
  .ant-form-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
  }
  .search-keyword {
    max-width: 800px;
    width: 57%;
    min-width: 400px;
    float: left;
    margin: 8px 20px  8px 0;
    display: flex;
    align-items: center;
    .ant-input {margin-right: 10px;}
    .gj-search {
      margin-left: 10px;
    }
    .reset-search {
      margin-left: 10px;
    }
  }
  .advanced-search{
    margin: 8px 20px  8px 0;
    .ant-popover {
      position: fixed;
      .form-container{
        width: 500px;
      }
    }
  }
}
</style>
